export class Mutex {

    private mutexQueue: ((value?: void | PromiseLike<void>) => void)[] = [];

    public queueCount(): number {
        return this.mutexQueue.length;
    }

    public unlock() {
        // Remove the func that finished
        this.mutexQueue.shift();
        // If queue is empty, nothing more to do
        if(this.mutexQueue.length <= 0) return;
        // Executre next in queue
        this.mutexQueue[0]();
    }

    public async lock(): Promise<void> {
        return new Promise<void>((resolve) => {
            // Push mutex resolve to wait queue
            this.mutexQueue.push(resolve);
            // If it is first in queue, allow access
            if(this.mutexQueue.length <= 1) resolve();
            this.mutexQueue;
        });
    }
}
